import { useImperativeHandle, forwardRef, useRef } from "react";
import SharePanel, { SharePanelRef } from "./index";
import { useConfigPage } from "@/hooks/useConfigPage/useConfigPage";
import { trackGdp } from "@/utils/gio-report";
import { getChannel } from "@/utils/tools";

export interface SharePanelWithContextRef {
  onOpen: () => void;
  onClose: () => void;
}

interface Props {
  onClose?: () => void;
  canShare?: boolean;
}

const SharePanelWithContext = forwardRef<SharePanelWithContextRef, Props>(
  ({ onClose, canShare = true }, ref) => {
    const { shareInfoRef, configPageQuery } = useConfigPage();
    const sharePanelRef = useRef<SharePanelRef>(null);

    const handleOpen = () => {
      if (!shareInfoRef?.current) {
        console.warn("分享信息未准备好");
        return;
      }
      sharePanelRef.current?.onOpen(shareInfoRef.current);
    };

    const handleClose = () => {
      sharePanelRef.current?.onClose();
      onClose?.();
    };

    const handleTrackClose = () => {
      trackGdp("P20189", "B002", {
        trackName: "充电_营销专题页_页面分享",
        origin: getChannel(),
        userType: "",
        versionId: configPageQuery?.data?.versionCode,
        pageId: configPageQuery?.data?.pageCode,
      });
      onClose?.();
    };

    useImperativeHandle(ref, () => ({
      onOpen: handleOpen,
      onClose: handleClose,
    }));

    return (
      <SharePanel
        ref={sharePanelRef}
        onClose={handleTrackClose}
        canShare={canShare}
      />
    );
  },
);

SharePanelWithContext.displayName = "SharePanelWithContext";

export default SharePanelWithContext;
